var React = require('react');

function IconWarning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M13 6.353l8.215 14.193H4.785L13 6.353M13 2L1 22.727h24zm1.091 15.273h-2.182v2.182h2.182zm0-6.545h-2.182v4.364h2.182z","transform":"translate(-1)","key":1})]);
}

IconWarning.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconWarning;

IconWarning.default = IconWarning;
